import { Text } from 'components/Text'

type PostTitleProps = {
  content: string
}

export const PostTitle = ({ content }: PostTitleProps) => {
  return (
    <Text as="h1" size="h1" weight="semiBold" color="accent-black">
      {content}
    </Text>
  )
}
